// extracted by mini-css-extract-plugin
module.exports = {"setAssetsPassward":"index_setAssetsPassward__V7k6U","setBtn":"index_setBtn__tMCd6","nextIcon":"index_nextIcon__9DehB"};